const getComponent = (state: AnyFixMe) => state.permanentBorder.component;

export { getComponent };
